import React, { useState } from "react";
import { dimColor } from "../../functions/utils";
import { BsCartPlusFill, BsFillCartDashFill } from "react-icons/bs";

function AddToCartButton({ product, color, addedToCart, handleAddToCart }) {
  const [hovered, setHovered] = useState(false);

  function handleHover(state) {
    setHovered(state);
  }

  return (
    <button
      disabled={product.quantity === 0 ? true : false}
      className="product-card-sm-button"
      onMouseEnter={() => handleHover(true)}
      onMouseLeave={() => handleHover(false)}
      style={{
        backgroundColor: hovered ? dimColor(color, 20) : color,
      }}
      onClick={() => {
        handleAddToCart(product);
      }}
    >
      {addedToCart ? <BsFillCartDashFill color="white" /> : <BsCartPlusFill color="white" />}
    </button>
  );
}

export default AddToCartButton;
